import { Box, CircularProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Covers the chart while a new time range (or refetch) is in flight so the previous
 * uPlot series stay visible but clearly marked as stale.
 */
export function YoutubeStatsChartFetchOverlay() {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.55),
      }}
    >
      <CircularProgress size={40} thickness={4} />
    </Box>
  );
}
